<div class="pt-5">

  <!-- MAIN COLUMN -->
  <div class="px-3 2xl:px-6">

    <publio-meta-connection
      [companyID]="companyID">
    </publio-meta-connection>

    <publio-tiktok-connection
      [companyID]="companyID"
      [preselectedPlatformId]="tiktokPlatformId"
      [preselectedSiteId]="tiktokSiteId"
      (platformDisconnected)="onTikTokDisconnected()">
    </publio-tiktok-connection>

    <article class="w-full bg-white">

      <!-- TABLE ACTIONS + TOP PAGINATION -->
      <div class="px-4 pt-4 sm:px-6 2xl:px-8">
        <div class="grid grid-cols-12 items-center gap-4 rounded-2xl bg-white/95 p-4 backdrop-blur">

          <!-- ADD BUTTON -->
          <div class="col-span-12 md:col-span-3 lg:col-span-3">
            <button
              class="primary-btn h-[50px] w-full rounded-xl px-5 text-sm font-semibold transition sm:w-auto"
              (click)="addNewPlatformToSite()">
              Add Platform
            </button>
          </div>

          <!-- TOP PAGINATION -->
          <div class="col-span-12 md:col-span-9 lg:col-span-9">
            <div class="flex items-center justify-end">
              <div class="w-fit overflow-hidden rounded-xl bg-white">
                <mat-paginator
                  [length]="totalItems"
                  [pageSize]="12"
                  showFirstLastButtons>
                </mat-paginator>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- TABLE SECTION -->
      <div class="px-4 py-4 sm:px-6 2xl:px-8 2xl:py-6">
        <div class="overflow-hidden bg-white">
          <div class="w-full overflow-x-auto">

            <mat-table
              [dataSource]="dataSource"
              matSort
              class="table-alternate !inline-table !w-full min-w-[900px]">

              <!-- ID -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  ID
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="font-medium text-gray-700">
                    {{ element.id }}
                  </span>
                </td>
              </ng-container>

              <!-- Platform -->
              <ng-container matColumnDef="platform">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Platform
                </th>

                <td mat-cell *matCellDef="let element">
                  <!-- For TikTok platforms - show disconnect/connect button based on connection status -->
                  <ng-container *ngIf="element.platform === 'TikTok'; else editButton">
                    <button
                      type="button"
                      class="group inline-flex max-w-[220px] items-center gap-1.5 border-0 bg-transparent p-0 text-left transition-colors duration-200 focus:outline-none focus:ring-2"
                      [ngClass]="{
                        'text-gray-800 hover:text-red-700 hover:underline focus:ring-red-100': element.platform === 'TikTok' && element.is_active,
                        'text-gray-500 hover:text-gray-700 focus:ring-gray-100': element.platform === 'TikTok' && !element.is_active
                      }"
                      (click)="(element.platform === 'TikTok' && element.is_active) ? disconnectPlatform(element) : showReconnectMessage(element)"
                      [matTooltip]="(element.platform === 'TikTok' && element.is_active) ? 'Disconnect TikTok account' : 'Connect TikTok account'">
                      
                      <span class="truncate">
                        {{ element.platform }}
                        <span *ngIf="element.platform === 'TikTok' && !element.is_active" class="ml-1 text-xs text-gray-500">(Disconnected)</span>
                      </span>

                      <mat-icon
                        inline
                        class="text-gray-400 transition-colors duration-200"
                        [ngClass]="{
                          'group-hover:text-red-700': element.platform === 'TikTok' && element.is_active,
                          'group-hover:text-gray-700': element.platform === 'TikTok' && !element.is_active
                        }">
                        {{ (element.platform === 'TikTok' && element.is_active) ? 'delete_outline' : 'sync' }}
                      </mat-icon>
                    </button>
                  </ng-container>

                  <!-- For other platforms - show edit button -->
                  <ng-template #editButton>
                    <button
                      type="button"
                      class="group inline-flex max-w-[220px] items-center gap-1.5 border-0 bg-transparent p-0 text-left text-gray-800 transition-colors duration-200 hover:text-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-100"
                      (click)="editPlatform(element)"
                      [matTooltip]="'Open platform settings'">

                      <span class="truncate">
                        {{ element.platform }}
                      </span>

                      <mat-icon
                        inline
                        class="text-gray-400 transition-colors duration-200 group-hover:text-blue-700">
                        edit
                      </mat-icon>
                    </button>
                  </ng-template>
                </td>
              </ng-container>

              <!-- Domain -->
              <ng-container matColumnDef="Domain">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Domain
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="block max-w-md truncate text-gray-700">
                    {{ element.site_domain }}
                  </span>
                </td>
              </ng-container>

              <!-- Social Media ID -->
              <ng-container matColumnDef="social_media_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Social Media ID
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="block max-w-xs truncate text-gray-700">
                    {{ element.social_media_id }}
                  </span>
                </td>
              </ng-container>



              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status Approval
                </th>

                <td mat-cell *matCellDef="let element" class="max-w-xs truncate">
                  <span class="inline-flex max-w-xs items-center rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs font-semibold text-gray-700">
                    {{ element.isApproved }}
                  </span>
                </td>
              </ng-container>

              <!-- Delete Column -->
              <!--
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  Delete
                </th>

                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    class="!bg-red-500 !text-white"
                    (click)="$event.stopPropagation();openDeletePlatformConfirm(element)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              -->

              <!-- Header and Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                  [ngClass]="{
                    'opacity-75': row.platform === 'TikTok' && !row.is_active
                  }">
              </tr>

            </mat-table>

          </div>
        </div>
      </div>

      <!-- BOTTOM PAGINATION -->
      <div class="px-4 pb-4 sm:px-6 2xl:px-8">
        <div class="flex items-center justify-end rounded-2xl bg-white/95 p-4 backdrop-blur">
          <div class="w-fit overflow-hidden rounded-xl bg-white">
            <mat-paginator
              [length]="totalItems"
              [pageSize]="12"
              showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
      </div>

    </article>

    <!-- TEMPLATES -->
    <ng-template #socialPlatformTmpl>
      <app-platform-form
        [formData]="selectedPlaform"
        [companyID]="selectedPlaform.companyID"
        (onSubmitClbk)="onSubmitClbk()">
      </app-platform-form>
    </ng-template>

    <!--
    <ng-template #confirmDeletePlatformTmpl>
      <div class="flex flex-col gap-4">
        <p>
          Are you sure you want to delete
          <b>{{ selectedPlaform.platform }}</b>
        </p>

        <div class="flex flex-row items-center justify-center gap-2">
          <button mat-button (click)="deletePlatform()">
            Confirm
          </button>

          <button mat-button (click)="dialog.closeAll();">
            Cancel
          </button>
        </div>
      </div>
    </ng-template>
    -->

  </div>

</div>